import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { AsstesService } from './asstes.service';
import { DeleteAssetListComponent } from '../delete-asset-list/delete-asset-list.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss'],
  preserveWhitespaces: false
})
export class AssetsComponent implements OnInit {
  assets: any;
  sequenceOfAssets: any;
  currentIndex: any;
  showingList = false;
  selectedItem;
  editTextForm = false;
  constructor(
    private _assetService: AsstesService,
    private modalService: NgbModal
  ) {

  }
  ngOnInit() {
    this.getCustomListData();
  }
  getCustomListData() {
    this._assetService.getAssets().subscribe(
      (res: any) => {
        if (!res.data.main) {
          res.data = {};
        }
        if (Object.keys(res.data).length >= 1) {
          this.showingList = true;
          this.sequenceOfAssets = ["main"];
          this.assets = res.data;
        } else {
          this.assets = {
            main: []
          }
          this.sequenceOfAssets = ["main"];
        }
      },
      (err) => {

      }
    );
  };

  addNewCategory() {
    this.assets.main.push({ _id: '', name: "" });
    this.showingList = true;
  }
  addItems(type, i,ind,assetID) {
    if(assetID){
    this.assets[type].push({ _id: '', name: '' });
    if(this.sequenceOfAssets.length !== 0)this.sequenceOfAssets = this.sequenceOfAssets.slice(0, i + 1);
    }
  }

  saveAssetData(assetName, row, column, assets, type) {
    if (assetName &&  this.assets[type][row].name === '') {
      var newAssetObj: any = {
        name: assetName
      }
      if (column !== 0) {
        let superParentAssetId: any = this.sequenceOfAssets.slice(-2)[0];
        let parentAssetId: any = this.sequenceOfAssets.slice(-1)[0];
        let parentAssetData: any = this.assets[superParentAssetId].filter(function(asset) {
          return asset._id === parentAssetId;
        });

        if (parentAssetData[0]) {
          newAssetObj.category = parentAssetData[0].name;
          newAssetObj.assetId = parentAssetData[0]._id;
        }
      }

      this._assetService.saveAsset(newAssetObj)
        .subscribe(
          (res: any) => {
            const id = res.data[0].id;
            this.assets[type][row]._id = id;
            if (this.sequenceOfAssets.length === 1) {
              if (this.sequenceOfAssets.length > 1) this.sequenceOfAssets.pop();
            } else if (this.currentIndex > column) {
              if (this.sequenceOfAssets.length > 1) {
                this.sequenceOfAssets.splice(column, this.assets[type][row] - column);
              }
            }
            this.assets[type][row].name = assetName;
            let key = this.assets[type][row]._id;
            if (key) {
              this.sequenceOfAssets.push(key);
              this.assets[key] = [{ _id: '', name: "" }];
              this.selectedItem = key;
            }
            this.currentIndex = column;
          },
          (err) => {}
        );
    } else {
      let updateName = {
        assetId : this.assets[type][row]._id,
        name : assetName
      }
      this._assetService.renameAsset(updateName).subscribe(
        (res)=>{
          this.assets[type][row].name = assetName; 
          this.editTextForm = false;
        }
      )
    }
  }

  updateIndex(i) {
    if (this.currentIndex === i) {
      if (this.sequenceOfAssets.length > 1) this.sequenceOfAssets.pop();
    } else if (this.currentIndex > i) {
      if (this.sequenceOfAssets.length > 1) {
        this.sequenceOfAssets = this.sequenceOfAssets.splice(0, i + 1);
      }
    }
    this.currentIndex = i;
  }
  getAssetId(type, assetID, name, i, ind) {
    if (name) {
      if (this.assets[assetID] !== undefined) {
        if (this.assets[type][ind].name) {
          this.updateIndex(i);
          this.selectedItem = assetID;
          this.sequenceOfAssets.push(assetID);
        }
      } else {
        this.sequenceOfAssets.push(assetID);
        this.updateIndex(i);
        this.assets[assetID] = [{ _id: '', name: "" }];
        this.selectedItem = assetID;
      }
    }
  }
  isAssetSelected(assetId) {
    if (this.sequenceOfAssets.includes(assetId)) {
      return true
    } else {
      return false
    }
  }

  deleteAsset(row, column, assets, type) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-small',
    };
    const modalRef = this.modalService.open(DeleteAssetListComponent, modalOptions);
    modalRef.componentInstance.assets = assets;
    modalRef.componentInstance.row = row;
    modalRef.componentInstance.assets = this.assets;
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.column = column;
    modalRef.componentInstance.sequenceOfAssets = this.sequenceOfAssets;
    modalRef.componentInstance.getAssetValues =(data)=>{
      this.showingList = data.showingList;
      this.assets = data.assets;
      this.sequenceOfAssets = data.sequenceOfAssets; 
    } 
  }
  editText() {
    this.editTextForm = true;
  }
  trueFunction(){
    this.editTextForm = false;
  }
}




// WEBPACK FOOTER //
// ./src/app/assets/assets.component.ts